import React from 'react';

export type FeatureCardHeadingLevel = 3 | 4;

type Props = {
  title: string;
  description: string;
  comingSoon?: boolean;
  headingLevel?: FeatureCardHeadingLevel;
  className?: string;
};

/**
 * Landing-page feature card. The heading level is configurable so the grouped
 * features section can render group titles as `h3` and the cards beneath them
 * as `h4`, keeping the document outline ordered.
 */
const FeatureCard: React.FC<Props> = ({
  title,
  description,
  comingSoon = false,
  headingLevel = 3,
  className = '',
}) => {
  const TitleTag = headingLevel === 4 ? 'h4' : 'h3';

  return (
    <div
      className={`rounded-2xl bg-white/90 p-5 shadow transition hover:shadow-md ${className}`}
    >
      <div className="flex items-start justify-between gap-3">
        <TitleTag className="text-lg font-semibold text-[#2f2f2d]">{title}</TitleTag>
        {comingSoon && (
          <span className="shrink-0 rounded-full bg-[#2f2f2d]/10 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-[#2f2f2d]">
            Coming soon
          </span>
        )}
      </div>
      <p className="mt-1 text-sm text-[#2f2f2d]/80">{description}</p>
    </div>
  );
};

export default FeatureCard;